module.exports = __webpack_public_path__ + "assets/Booth-front.png";


//////////////////
// WEBPACK FOOTER
// ./images/Booth-front.png
// module id = 298
// module chunks = 0